module.exports = __webpack_public_path__ + "static/media/box.64c7b85a.svg";